<p-toast></p-toast>

<!-- On a phone the page area already has its padding: the card goes edge to edge of it. -->
<div class="px-0 py-2 md:p-2">
  <div class="main-card p-3">
    <div class="font-semibold text-xl mb-2">Egzamin wewnętrzny</div>

    <form
      [formGroup]="internalExamSettingsForm"
      (ngSubmit)="saveInternalExamSettings()"
      autocomplete="off"
    >
      <div class="form-decorator top-decorator flex align-items-center">
        <label class="title" for="internal-exam-header">Nagłówek</label>
        <div class="form-wraper">
          <input
            id="internal-exam-header"
            type="text"
            pInputText
            formControlName="header"
            maxlength="100"
            placeholder="Wpisz nagłówek widoczny dla kursanta"
          />
          @if (
            internalExamSettingsForm.controls.header.touched &&
            internalExamSettingsForm.controls.header.invalid
          ) {
            <small class="error-message">Nagłówek jest wymagany.</small>
          }
        </div>
      </div>

      <div class="form-decorator flex align-items-start">
        <label class="title pt-2" for="internal-exam-text">Tekst</label>
        <div class="form-wraper">
          <textarea
            id="internal-exam-text"
            pInputTextarea
            formControlName="text"
            maxlength="500"
            rows="5"
            placeholder="Wpisz tekst widoczny dla kursanta"
          ></textarea>
          @if (
            internalExamSettingsForm.controls.text.touched &&
            internalExamSettingsForm.controls.text.invalid
          ) {
            <small class="error-message">Tekst jest wymagany.</small>
          }
        </div>
      </div>

      <div class="form-decorator flex align-items-start">
        <div class="title pt-2">Logo</div>
        <div class="form-wraper flex flex-column gap-2">
          @if (!editingLogo) {
            <div class="flex justify-content-between align-items-center">
              @if (logoUrl) {
                <img [src]="resolveImageUrl(logoUrl)" alt="Logo OSK" width="200" />
              } @else {
                <span class="text-sm text-400">Brak pliku graficznego</span>
              }
              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Edytuj logo"
                  [disabled]="saving || loading"
                  (click)="enableLogoEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-pencil"></i>
                </button>
                @if (logoUrl) {
                  <button
                    type="button"
                    class="transparent-button text-red-500"
                    title="Usuń logo"
                    [disabled]="saving || loading"
                    (click)="removeLogo()"
                    data-clarity-unmask="true"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                }
              </div>
            </div>
          } @else {
            <fas-services-upload
              class="w-full"
              [environment]="webApiUrl"
              [allowedExtensions]="['.png', '.jpg', '.jpeg', '.webp']"
              [mainMessage]="'Wybierz plik z dysku lub przeciągnij tu.'"
              [mainIcon]="'pi-image'"
              [buttonIcon]="'pi-folder'"
              [multiple]="false"
              (fileSelected)="handleLogoSelected($event)"
            ></fas-services-upload>
            <div class="flex gap-2">
              <button
                type="button"
                class="transparent-button"
                title="Anuluj zmianę logo"
                [disabled]="saving"
                (click)="cancelLogoEditing()"
                data-clarity-unmask="true"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          }
          <small class="text-gray-500">
            Logo, nagłówek i tekst są pokazywane kursantowi na ekranie startowym egzaminu
            wewnętrznego. Wybrany plik zostanie przesłany po kliknięciu „{{ saveButtonLabel }}”.
          </small>
        </div>
      </div>

      <div class="form-decorator flex align-items-center">
        <div class="title">Dodaj limit czasu</div>
        <div class="form-wraper flex align-items-center gap-2">
          <p-checkbox
            inputId="internal-exam-retry-limit-enabled"
            formControlName="retryLimitEnabled"
            [binary]="true"
          ></p-checkbox>
          <label class="text-sm text-gray-600" for="internal-exam-retry-limit-enabled">
            Kursant może podejść do egzaminu ponownie dopiero po upływie ustawionego czasu.
          </label>
        </div>
      </div>

      @if (retryLimitEnabled) {
        <div class="form-decorator flex align-items-center">
          <div class="title">Czas do kolejnego podejścia</div>
          <div class="form-wraper flex flex-wrap align-items-center gap-3">
            <div class="time-field">
              <label for="internal-exam-retry-hours">Godziny</label>
              <p-inputNumber
                inputId="internal-exam-retry-hours"
                formControlName="retryHours"
                [min]="0"
                [max]="999"
                [showButtons]="true"
                suffix=" h"
              ></p-inputNumber>
            </div>
            <div class="time-field">
              <label for="internal-exam-retry-minutes">Minuty</label>
              <p-inputNumber
                inputId="internal-exam-retry-minutes"
                formControlName="retryMinutes"
                [min]="0"
                [max]="59"
                [showButtons]="true"
                suffix=" min"
              ></p-inputNumber>
            </div>
            @if (
              (internalExamSettingsForm.controls.retryHours.touched &&
                internalExamSettingsForm.controls.retryHours.invalid) ||
              (internalExamSettingsForm.controls.retryMinutes.touched &&
                internalExamSettingsForm.controls.retryMinutes.invalid)
            ) {
              <small class="error-message w-full">
                Podaj liczbę godzin od 0 do 999 oraz minut od 0 do 59.
              </small>
            }
          </div>
        </div>
      }

      <div class="flex justify-content-end mt-3">
        <p-button
          type="submit"
          [label]="saveButtonLabel"
          icon="pi pi-save"
          [disabled]="internalExamSettingsForm.invalid || saving || loading"
          data-clarity-unmask="true"
        ></p-button>
      </div>
    </form>
  </div>
</div>
